import { render, staticRenderFns } from "./AppNotifyHeader.vue?vue&type=template&id=12448ae4"
import script from "./AppNotifyHeader.vue?vue&type=script&lang=js"
export * from "./AppNotifyHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports